import { render, staticRenderFns } from "./AttachmentsDialog.vue?vue&type=template&id=1ea45bcb"
import script from "./AttachmentsDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports